import React from "react";
import PropTypes from "prop-types";

const InputField = ({
  label,
  type = "text",
  id,
  name,
  value,
  placeholder,
  onChange,
  required = false,
  className = "",
}) => {
  return (
    <div className={`form-group ${className}`}>
      {label && (
        <label htmlFor={id} className="form-label">
          {label}
        </label>
      )}
      <input
        type={type}
        id={id}
        name={name}
        value={value}
        placeholder={placeholder}
        onChange={onChange}
        className="form-control"
        required={required}
      />
    </div>
  );
};


InputField.propTypes = {
  label: PropTypes.string,
  type: PropTypes.string,
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.string,
  placeholder: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  required: PropTypes.bool,
  className: PropTypes.string,
};


InputField.defaultProps = {
  type: "text",
  value: "",
  placeholder: "",
  required: false,
  className: "",
};

export default InputField;
